import React, { useState } from "react"
import { Text } from "./Text";
import Modal from 'react-modal';


export const Terms = () => {
  const [clicked, setClicked] = useState(false);
  
  const handleClick = () => {
    if (!clicked) {
      setClicked(true);
    } else {
      setClicked(false);
    }
  }

  const closeModal = () => {
    setClicked(false);
  }

  return (
    <div className="terms__container">
      <button onClick={handleClick} className="terms-btn">
        Privacy Policy
      </button>
      <Modal
        isOpen={clicked}
        onRequestClose={closeModal}
      >
        <div>
          <button className="close-btn" onClick={closeModal}>X</button>
        </div>
        <Text />
      </Modal>
    </div>
  )
}